import styled from "@emotion/styled";
import { Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InfoCircleOutlined } from "@ant-design/icons";

import React, { FC } from "react";

interface ProductSGWaitingTimeProps {
  is_active: boolean;
}

const ProductSGWaitingTime: FC<ProductSGWaitingTimeProps> = ({ is_active }) => {
  return (
    <FormWrapper>
      <Form.Item
        label="เรื่องราว (Story)"
        name="sg_waiting_time"
        //rules={[{ required: is_active, message: "กรุณากรอกระยะเวลารอรับสินค้า" }]}
        tooltip={{
          title: <TooltipContent />,
          icon: <InfoCircleOutlined />,
          color: "#ffffff",
        }}
      >
        <TextArea
          placeholder="เรื่องราว (Story)  ทำไมสินค้านี้จึงน่าสนใจ"
          showCount
          maxLength={5000}
          rows={10}
        />
      </Form.Item>
    </FormWrapper>
  );
};

const TooltipContent = () => {
  return (
    <div style={{ width: "100%" }}>
      <h6 style={{ color: "black" }}>ตัวอย่าง "เรื่องราว (Story)"</h6>
      <p style={{ color: "black" }}>
        ทำไมสินค้านี้จึงน่าสนใจ สินค้ามีความแตกต่างกัน มีการจัดส่งสินค้า
        มีการส่งข้อมูลสินค้า มีการส่งข้อมูลการขาย มีการส่งข้อมูลการซื้อสินค้า
      </p>
    </div>
  );
};

export default ProductSGWaitingTime;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
  margin-bottom: 10px;
`;
